import { render, staticRenderFns } from "./RouteLoader.vue?vue&type=template&id=76389680&scoped=true&"
import script from "./RouteLoader.vue?vue&type=script&lang=js&"
export * from "./RouteLoader.vue?vue&type=script&lang=js&"
import style0 from "./RouteLoader.vue?vue&type=style&index=0&id=76389680&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76389680",
  null
  
)

export default component.exports